(window as any).global = window;

import { enableProdMode, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, withXhr, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { registerLocaleData, APP_BASE_HREF } from '@angular/common';
import localeHe from '@angular/common/locales/he';
import { Amplify } from 'aws-amplify';
import config from 'src/assets/config/config.json';

import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routes';
import { AuthInterceptor } from './app/core/interceptors/auth-interceptor';
import { environment } from './environments/environment';

registerLocaleData(localeHe);
Amplify.configure(config.AmplifyConfig as any, {
  Storage: {
    S3: { prefixResolver: async () => { return ''; }}
  }
});

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(APP_ROUTES, withHashLocation()),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideServiceWorker('sw-bypass.js', {
      enabled: environment.enableServiceWorker,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: LOCALE_ID, useValue: 'he' },
  ]
}).catch(err => console.error(err));
